import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

type AlertVariation = 'success' | 'warning' | 'error' | 'info' | 'primary' | 'secondary';
type AlertSize = 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'webmodule-order-alert',
  templateUrl: './alert.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class AlertComponent {
  @Input({ required: true }) title!: string;
  @Input() variation: AlertVariation = 'info';
  @Input() size: AlertSize = 'sm';
  @Input() showIcon = true;
}
